<div id="deleteSearch" class="clear-input__icon-wrapper active" (click)="clearSearchText()">
  <svg class="clear-input__icon fill-brand-core cursor-pointer">
    <use xlink:href="./assets/icons/connect-icons.svg#Delete-Solid"></use>
  </svg>
</div>
